module.exports = __webpack_public_path__ + "static/media/icon-minimize.9661ba0b.svg";